// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BERelationship } from './BERelationship';
import { BEComponent } from './BEComponent';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { ComponentDependExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/EntityModel/ComponentDependExtend';
/**
 * 组件依赖 实体类
 * 组件依赖，源依赖于目标
 */
export class ComponentDepend extends BERelationship {
  /** 依赖方组件 的ID */
  private _dependComponent_ID: string;

  /** 获取：依赖方组件 的ID */
  public get dependComponent_ID() {
    return this._dependComponent_ID;
  }

  /** 设置：依赖方组件 的ID */
  public set dependComponent_ID(value: string) {
    this._dependComponent_ID = value;
  }

  /** 依赖方组件  */
  private _dependComponent: BEComponent;

  /** 获取：依赖方组件  */
  public get dependComponent() {
    return this._dependComponent;
  }

  /** 设置：依赖方组件  */
  public set dependComponent(value: BEComponent) {
    this._dependComponent = value;
    if (value !== null) {
      this.dependComponent_ID = value.id;
    } else {
      this.dependComponent_ID = '';
    }
  }

  /** 被依赖组件 的ID */
  private _dependedComponent_ID: string;

  /** 获取：被依赖组件 的ID */
  public get dependedComponent_ID() {
    return this._dependedComponent_ID;
  }

  /** 设置：被依赖组件 的ID */
  public set dependedComponent_ID(value: string) {
    this._dependedComponent_ID = value;
  }

  /** 被依赖组件  */
  private _dependedComponent: BEComponent;

  /** 获取：被依赖组件  */
  public get dependedComponent() {
    return this._dependedComponent;
  }

  /** 设置：被依赖组件  */
  public set dependedComponent(value: BEComponent) {
    this._dependedComponent = value;
    if (value !== null) {
      this.dependedComponent_ID = value.id;
    } else {
      this.dependedComponent_ID = '';
    }
  }

  constructor() {
    super();
    ComponentDependExtend.Init(this);
    this._dependComponent_ID = '';
    this._dependComponent = null;
    this._dependedComponent_ID = '';
    this._dependedComponent = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ComponentDepend, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.dependComponent_ID = element.dependComponent_ID;
      if (hasReference && element.dependComponent !== null) {
        this.dependComponent = element.dependComponent;
      }
      this.dependedComponent_ID = element.dependedComponent_ID;
      if (hasReference && element.dependedComponent !== null) {
        this.dependedComponent = element.dependedComponent;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.dependComponent_ID = json.DependComponent_ID;
    // if (json.DependComponent !== null) {
    //   this.dependComponent = BEComponent.Create(json.DependComponent);
    // }
    this.dependedComponent_ID = json.DependedComponent_ID;
    // if (json.DependedComponent !== null) {
    //   this.dependedComponent = BEComponent.Create(json.DependedComponent);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.DependComponent_ID = this.dependComponent_ID;
    json.DependedComponent_ID = this.dependedComponent_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): ComponentDepend {
    const componentDepend = new ComponentDepend();
    componentDepend.Deserialize(json);
    componentDepend.json = json;
    return componentDepend;
  }
}
